import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetAiUsageLogsQuery = (params = {}) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_AI_USAGE_LOGS, params],
    queryFn: () => api.get(API_ROUTES.GET_AI_USAGE_LOGS, { params }),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data?.data ?? [],
    pagination: data?.data?.pagination ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};

export const useGetAiUsageLogStatsQuery = (params = {}, enabled = true) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_AI_USAGE_LOG_STATS, params],
    queryFn: () => api.get(API_ROUTES.GET_AI_USAGE_LOG_STATS, { params }),
    placeholderData: keepPreviousData,
    enabled,
  });
  return {
    data: data?.data?.data ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};

export const useGetAiUsageLogByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_AI_USAGE_LOG_BY_ID, id],
    queryFn: () =>
      api.get(API_ROUTES.GET_AI_USAGE_LOG_BY_ID.replace(":id", id)),
    enabled: !!id,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetAiUsageLogNetworksQuery = (params = {}, enabled = true) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_AI_USAGE_LOG_NETWORKS, params],
    queryFn: () => api.get(API_ROUTES.GET_AI_USAGE_LOG_NETWORKS, { params }),
    placeholderData: keepPreviousData,
    enabled,
  });
  return {
    data: data?.data?.data ?? [],
    isPending,
    isFetching,
    isError,
    error,
  };
};

export const useGetAiUsageLogNetworkAgentsQuery = (networkId, params = {}) => {
  // No keepPreviousData here: networkId changing means a different trading
  // identity, so we want a loading state rather than another network's agents
  // flashing on screen.
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_AI_USAGE_LOG_NETWORK_AGENTS, networkId, params],
    queryFn: () =>
      api.get(
        API_ROUTES.GET_AI_USAGE_LOG_NETWORK_AGENTS.replace(":networkId", networkId),
        { params }
      ),
    enabled: !!networkId,
  });
  return {
    data: data?.data?.data ?? [],
    isPending,
    isFetching,
    isError,
    error,
  };
};
